import ContactUsForm from '@/components/dashboard/contact-us/ContactUsForm';

const ContactUsPage = () => {
  return (
    <div className='bg-light-blue-grey w-full h-full flex flex-col gap-[1px] dark:bg-jet-black'>
      <ContactUsForm />
    </div>
  );
};

ContactUsPage.signedInDesign = true;

ContactUsPage.metadata = {
  title: 'NettyWorth | Contact Us for Support & Inquiries',
  description: "Need help or have questions? Contact the NettyWorth team for support, partnership inquiries, or general information. We're here to assist you.",
  image: `${process.env.NEXT_PUBLIC_SITE_URL}/thumbnail.png`,
  contentType: 'website',
};

export default ContactUsPage;
